import { createUseStyles } from 'react-jss';

import { BulletColor } from './types';

const bulletMap = {
  magenta: {
    base: {
      background: 'var(--x-border-4)',
    },
    active: { background: 'var(--x-accent-1-1)' },
  },
  white: {
    base: { background: '#fff', opacity: 0.4 },
    active: { background: '#fff', opacity: 1 },
  },
};

const useStyles = createUseStyles<string, { color: BulletColor }>(
  {
    root: ({ color }) => ({
      ...bulletMap[color].base,
      borderRadius: '50%',
      cursor: 'pointer',
      display: 'inline-block',
      height: 8,
      width: 8,
    }),
    isActive: ({ color }) => ({
      ...bulletMap[color].active,
    }),
  },
  { name: 'CBullet' },
);

export default useStyles;
